import React, { useState } from "react";
import {
  Col,
  Carousel,
  Stack,
  Card,
  Row,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import "./carousel.scss";
import Buttons from "../Buttons";
import { Icons } from "../Icons";
import BarChart from "../BarChart";
import SavingsBarChart from "../SavingsBarChart";
import { addCommas } from "../../helpers/helpers";
import { FUNDNAME } from "../../constants/constants";
import CustomizedSwitches from "../Switch";
import cmsConfig from "../../redux/helpers/cmsConfig";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";

const CarouselComponent = (props) => {
  const [carousalIndex, setCarousalIndex] = useState(0);
  const handleOnSelect = (selectedIndex) => {
    setCarousalIndex(selectedIndex);
    props.setPotIndex(selectedIndex);
  };
  const {
    type,
    interval,
    articleCarouselData,
    cardCarouselData,
    savingsBreakdownCarouselData,
    savingsBreakdownData,
    currentContribution,
    investmentCardCarouselData,
    rafinaltimeline,
  } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setSelectedIndex(selectedIndex);
  };
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false); //eslint-disable-line
  const handleMouseEnter = () => {
    if (!isButtonClicked) {
      setIsHovered(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isButtonClicked) {
      setIsHovered(false);
    }
  };
  const onClickRead = (item) => {
    let path = item?.route?.path?.split("/");
    if (path[1] === "learn" && path.length > 2) {
      path.splice(2, 0, "article");
    }
    let newPath = path.join("/");
    navigate(newPath, {
      state: {
        item: item,
        learnLandingScreenData: props.learnLandingScreenData,
        breadCrumb: item?.properties?.articleBreadcrumb,
        data: props.data,
        modalTitle: props.modalTitle,
        investorId: props.investorId,
      },
    });
    window.scroll(0, 0);
  };
  const onClickVideo = (item) => {
    let path = item.route.path.split("/");
    if (path[1] === "learn" && path.length > 2) {
      path.splice(2, 0, "video");
    }
    let newPath = path.join("/");
    navigate(newPath, {
      state: {
        url: item?.properties?.articleBody?.items?.find(
          (item) => item.content.contentType === "videoBlock", //eslint-disable-line
        )?.content?.properties?.video,
        breadCrumb: item?.properties?.articleBreadcrumb,
        data: props.data,
        thumbnail: item?.properties?.articleBody?.items?.find(
          (item) => item.content.contentType === "videoBlock", //eslint-disable-line
        )?.content?.properties?.thumbnailImage[0]?.url,
        item: item,
      },
    });
    window.scroll(0, 0);
  };
  const onClickWebinar = (item) => {
    let path = item.route.path.split("/");
    if (path[1] === "learn" && path.length > 2) {
      path.splice(2, 0, "webinar");
    }
    let newPath = path.join("/");
    navigate(newPath, {
      state: {
        item: item,
        learnLandingScreenData: props.learnLandingScreenData,
        breadCrumb: item?.properties?.articleBreadcrumb,
        data: props.data,
      },
    });
    window.scroll(0, 0);
  };

  const tooltip = (
    <Popover id="popover-contained" className="ec-popover-inner">
      <Popover.Body style={{ paddingTop: "5px" }}>
        <div className="Why-cant-I-edit-cer mb-2">
          <strong>Employer contribution</strong>
        </div>
        <div className="Changing-your-title mb-2">
          We&apos;ve included your salary sacrifice here (instead of under the
          employee contribution).
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      {type === "ArticleCarousel" ? (
        <Carousel defaultActiveIndex={0}>
          {articleCarouselData?.map((item, index) => {
            return (
              <Carousel.Item key={index} interval={interval}>
                <Row>
                  <Col
                    className="carousel-image"
                    xs={{ span: 12, order: 1 }}
                    md={{ span: 5, order: 2 }}
                    lg={{ span: 5, order: 2 }}
                  >
                    <img
                      height="100%"
                      width="100%"
                      alt={
                        item.content.properties.articleCarouselImage.items[0]
                          .content.properties.alternateTextSingle
                      }
                      src={`${cmsConfig?.baseUrl}${item.content.properties.articleCarouselImage.items[0].content.properties.image[0].url}`}
                    ></img>
                  </Col>
                  <Col
                    xs={{ span: 12, order: 1 }}
                    md={{ span: 7, order: 2 }}
                    lg={{ span: 7, order: 2 }}
                    className={
                      item?.content?.properties?.articleTheme?.label ===
                      "Pale Fuchsia"
                        ? "Pale-Fuchsia"
                        : item?.content?.properties?.articleTheme?.label
                    }
                  >
                    <p className="ms-3 mt-2 me-2 title">
                      {item.content.properties.articleCarouselTitle}
                    </p>
                    <div
                      className="ms-3 mb-2 me-2 description"
                      dangerouslySetInnerHTML={{
                        __html:
                          item?.content?.properties?.articleCarouselDescription
                            ?.markup,
                      }}
                    ></div>

                    {item?.content?.properties?.articleCarouselArticleLink[0]
                      ?.route?.path != null &&
                    item?.content?.properties?.articleCarouselArticleLink[0]
                      ?.route?.path != "/" ? (
                      <Buttons
                        name={
                          item?.content?.properties
                            ?.articleCarouselArticleLink[0]?.title
                        }
                        className="btn ms-3 mb-3"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        iconname={
                          item?.content?.properties?.articleTheme?.label ===
                            "Pale Fuchsia" ||
                          item?.content?.properties?.articleTheme?.label ===
                            "Turquoise" ||
                          item?.content?.properties?.articleTheme?.label ===
                            "White"
                            ? isHovered
                              ? "arrow-right-white"
                              : "arrow-right"
                            : item?.content?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.content?.properties?.articleTheme
                                  ?.label === "Fuchsia"
                              ? isHovered
                                ? "arrow-right"
                                : "arrow-right-white"
                              : ""
                        }
                        variantname="icon-sixteen-px"
                        handleClick={() =>
                          navigate(
                            item?.content?.properties
                              ?.articleCarouselArticleLink[0]?.route?.path,
                            {
                              state: {
                                breadCrumb:
                                  item?.content?.properties
                                    ?.articleCarouselTitle,
                                homePromo: true,
                              },
                            }, //eslint-disable-line
                          )
                        }
                      />
                    ) : item?.content?.properties?.articleCarouselArticleLink[0]
                        ?.url != null ? (
                      <Buttons
                        name={
                          item?.content?.properties
                            ?.articleCarouselArticleLink[0]?.title
                        }
                        className="btn ms-3 mb-3"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        iconname={
                          item?.content?.properties?.articleTheme?.label ===
                            "Pale Fuchsia" ||
                          item?.content?.properties?.articleTheme?.label ===
                            "Turquoise" ||
                          item?.content?.properties?.articleTheme?.label ===
                            "White"
                            ? isHovered
                              ? "arrow-right-white"
                              : "arrow-right"
                            : item?.content?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.content?.properties?.articleTheme
                                  ?.label === "Fuchsia"
                              ? isHovered
                                ? "arrow-right"
                                : "arrow-right-white"
                              : ""
                        }
                        variantname="icon-sixteen-px"
                        handleClick={() => {
                          const linkObj =
                            item?.content?.properties
                              ?.articleCarouselArticleLink[0];
                          const targetToUse =
                            linkObj?.target === "_blank" ? "_blank" : "_self";

                          window.open(linkObj?.url, targetToUse); //eslint-disable-line
                        }}
                      />
                    ) : null}
                  </Col>
                </Row>
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : type === "Card Carousel" ? (
        <Carousel interval={interval}>
          {cardCarouselData.map((item, index) => {
            return <Carousel.Item key={index}>{item.content}</Carousel.Item>;
          })}
        </Carousel>
      ) : type === "Savings Breakdown" ? (
        <>
          <Col sm={12} xs={12}>
            <BarChart
              data={savingsBreakdownData}
              drawDown={false}
              showLine={false}
              mobile={true}
              selectedIndex={selectedIndex}
            />
          </Col>
          <Carousel
            interval={interval}
            onSelect={(e) => handleSelect(e)}
            className={
              selectedIndex === 0
                ? "control-prev"
                : savingsBreakdownCarouselData.length - 1 === selectedIndex
                  ? "control-next"
                  : ""
            }
          >
            {savingsBreakdownCarouselData.map((item, index) => {
              return (
                <Carousel.Item
                  key={index}
                  className={
                    item.dbPension === true
                      ? "carousel-dbcard-item"
                      : item.productTypeId
                        ? "carousel-drawdown-item"
                        : "carousel-card-item"
                  }
                >
                  {item.status === "Active" && !item.productTypeId ? (
                    <div className="active-div">
                      <span className="active-text">ACTIVE</span>
                    </div>
                  ) : (
                    <div className="inactive-text"></div>
                  )}
                  {}
                  {item.dbPension === true ? (
                    <div className="dbcard-text-wrapper">
                      <span className="db-pension-text">
                        {"You also have a DB pension"}
                      </span>
                      <Link to="">
                        <span className="icon">
                          <Icons iconname="edit" variant="icon-sixteen-px" />
                        </span>
                        <Buttons className="tertiary" name="View it here" />
                      </Link>
                    </div>
                  ) : (
                    <div className="card-text-wrapper">
                      <span>{item.employerId}</span>
                      <span>{item.employerName}</span>
                      <span>
                        <div className="carousel-total-value">
                          £{addCommas(Math.trunc(item.totalBalance))}.
                          <span className="carousel-small-digit">
                            {(item.totalBalance % 1).toFixed(2).substring(2)}
                          </span>
                        </div>
                      </span>
                    </div>
                  )}
                </Carousel.Item>
              );
            })}
          </Carousel>
        </>
      ) : type === "Current contribution carousal" ? (
        <>
          <div className="carousal-employer-name">
            {currentContribution &&
              currentContribution[carousalIndex] &&
              currentContribution[carousalIndex].potId}
          </div>
          <div className="carousal-employer-value">
            {currentContribution &&
              currentContribution[carousalIndex] &&
              currentContribution[carousalIndex].potName}
          </div>
          {currentContribution && currentContribution.length > 1 ? (
            <Carousel interval={null} onSelect={handleOnSelect}>
              {currentContribution &&
                currentContribution.map((item, index) => {
                  return (
                    <Carousel.Item key={index}>
                      <Stack
                        direction="horizontal"
                        className="h-100 justify-content-center align-items-center stack-card"
                      >
                        {item?.salarySacrificeFlag ? (
                          <span className="current-contribution-value">
                            {(
                              parseFloat(item?.potPercentage) +
                              parseFloat(item?.salarySacrificePercentage)
                            ).toFixed(2)}
                            %
                          </span>
                        ) : item?.potPercentage ? (
                          <span className="current-contribution-value">
                            {Number(item.potPercentage).toFixed(2)}%
                          </span>
                        ) : (
                          ""
                        )}
                      </Stack>
                    </Carousel.Item>
                  );
                })}
            </Carousel>
          ) : (
            <div className="h-100 justify-content-center align-items-center stack-card hstack">
              {currentContribution && currentContribution ? (
                currentContribution[carousalIndex]?.salarySacrificeFlag ? (
                  <span className="current-contribution-value">
                    {(
                      parseFloat(
                        currentContribution[carousalIndex]?.potPercentage, //eslint-disable-line
                      ) +
                      parseFloat(
                        currentContribution[carousalIndex]
                          ?.salarySacrificePercentage, //eslint-disable-line
                      )
                    )?.toFixed(2)}
                    %
                  </span>
                ) : (
                  <span className="current-contribution-value">
                    {/* prettier-ignore */}
                    {Number(
                      currentContribution[carousalIndex]?.potPercentage, //eslint-disable-line
                    ).toFixed(2)}
                    %
                  </span>
                )
              ) : (
                ""
              )}
            </div>
          )}
        </>
      ) : type === "Savings Carousel" ? (
        <>
          <Col sm={12} xs={12}>
            {props.savingsBreakdown &&
            props.drawDownBreakdown &&
            props.savingsPotBreakdown?.potInfo?.length >= 1 &&
            props.drawDownPotBreakdown?.potInfo?.length >= 1 ? (
              <SavingsBarChart
                savingsPotBreakdown={props.savingsPotBreakdown}
                drawDownPotBreakdown={props.drawDownPotBreakdown}
                savingsPercentages={props.savingsPercentages}
                totalPotPercentage={props.totalPotPercentage}
                savingsBreakdown={props.savingsBreakdown}
                drawDownBreakdown={props.drawDownBreakdown}
                mobileView={props.mobileView}
                selectedIndex={selectedIndex}
              />
            ) : props.savingsBreakdown ? (
              !props.viewAllPots ? (
                <SavingsBarChart
                  savingsPotBreakdown={props.savingsPotBreakdown}
                  savingsPercentages={props.savingsPercentages}
                  savingsBreakdown={props.savingsBreakdown}
                  handleSavingsViewBreakdown={props.handleSavingsViewBreakdown}
                  mobileView={props.mobileView}
                  selectedIndex={selectedIndex}
                />
              ) : (
                ""
              )
            ) : props.drawDownBreakdown ? (
              <SavingsBarChart
                drawDownPotBreakdown={props.drawDownPotBreakdown}
                drawDownPercentages={props.drawDownPercentages}
                drawDownBreakdown={props.drawDownBreakdown}
                handleSavingsViewBreakdown={props.handleSavingsViewBreakdown}
                mobileView={props.mobileView}
                selectedIndex={selectedIndex}
              />
            ) : (
              <SavingsBarChart
                viewPotInfo={props.savingsCarouselData}
                percentages={props.percentages}
                mobileView={props.mobileView}
                selectedIndex={selectedIndex}
                savingsBreakdown={props.savingsBreakdown}
                drawDownBreakdown={props.drawDownBreakdown}
                savingsPots={props.savingsPots}
                drawDownPots={props.drawDownPots}
                fundName={props.fundName}
              />
            )}
          </Col>
          <Col sm={12} xs={12} className="savings-carousel mt-5">
            {props.savingsBreakdown && props.drawDownBreakdown ? (
              <>
                <Carousel
                  interval={interval}
                  onSelect={(e) => handleSelect(e)}
                  className={
                    selectedIndex === 0
                      ? "control-prev"
                      : props?.drawDownPotBreakdown?.potInfo?.length - 1 ===
                          selectedIndex
                        ? "control-next"
                        : ""
                  }
                  controls={
                    parseFloat(props.savingsPotBreakdown?.totalValue) > 0 &&
                    parseFloat(props.drawDownPotBreakdown?.totalValue) > 0
                  }
                  indicators={
                    parseFloat(props.savingsPotBreakdown?.totalValue) > 0 &&
                    parseFloat(props.drawDownPotBreakdown?.totalValue) > 0
                  }
                >
                  {props.savingsPotBreakdown?.potInfo?.length > 1 ? (
                    parseFloat(props.savingsPotBreakdown?.totalValue) === 0 ? (
                      ""
                    ) : (
                      <Carousel.Item
                        key={0}
                        style={{ backgroundColor: "var(--fuchsia-100)" }}
                        className="savings-carousel-card-item"
                      >
                        <div>
                          <Card className="allpot-info-card">
                            <Card.Body className="text-center">
                              <p className="allpot-text mb-0">
                                {"Savings value"}
                              </p>
                              <div className="mt-2 mb-2">
                                <span className="allpot-value">
                                  {" "}
                                  £
                                  {addCommas(
                                    props.savingsPotBreakdown?.totalValue?.split(
                                      ".", // eslint-disable-line
                                    )[0], // eslint-disable-line
                                  )}
                                </span>
                                <span className="allpot-subsetsmall">{`.${
                                  props.savingsPotBreakdown?.totalValue?.split(
                                    ".", // eslint-disable-line
                                  )[1]
                                }`}</span>
                              </div>
                              <Buttons
                                name="View all pots"
                                className="tertiary allpot-view-breakdown-btn"
                                handleClick={props.handleViewAllPots}
                                id={FUNDNAME.SAVINGS}
                              ></Buttons>
                            </Card.Body>
                          </Card>
                        </div>
                      </Carousel.Item>
                    )
                  ) : (
                    ""
                  )}
                  {props.savingsPotBreakdown?.potInfo?.length === 1 ? (
                    <Carousel.Item
                      key={0}
                      className="savings-carousel-card-item"
                    >
                      <div className="carousel-text-wrapper">
                        {props?.savingsPotBreakdown?.potInfo[0]?.status ===
                        "Active" ? (
                          <div className="d-flex justify-content-center">
                            <p className="active-status-text">
                              {props?.savingsPotBreakdown?.potInfo[0]?.status}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        <span className="contribution-name">
                          {props?.savingsPotBreakdown?.potInfo[0]?.potId}
                        </span>
                        <span className="contribution-name">
                          {props?.savingsPotBreakdown?.potInfo[0]?.potName}
                        </span>
                        <div className="mt-3">
                          <span className="pot-breakdown-value">
                            {" "}
                            £
                            {`${addCommas(
                              props?.savingsPotBreakdown?.potInfo[0]?.totalPotValue?.split(
                                ".", // eslint-disable-line
                              )[0], // eslint-disable-line
                            )}`}
                          </span>
                          <span className="pot-breakdown-subsetsmall">
                            {`.00`}
                          </span>
                        </div>
                        {parseFloat(
                          props?.savingsPotBreakdown?.potInfo[0]?.totalPotValue, // eslint-disable-line
                        ) === 0 ? (
                          ""
                        ) : (
                          <Buttons
                            name="View breakdown"
                            className="tertiary pot-view-breakdown-btn"
                            handleClick={props.handleSavingsViewBreakdown}
                            id={`${props?.savingsPotBreakdown?.potInfo[0]?.potId}-savings`}
                          ></Buttons>
                        )}
                      </div>
                    </Carousel.Item>
                  ) : (
                    ""
                  )}
                  {props.drawDownPotBreakdown?.potInfo?.length > 1 ? (
                    <Carousel.Item
                      key={1}
                      style={{ backgroundColor: "var(--blue-100)" }}
                      className="savings-carousel-card-item"
                    >
                      <Card className="drawdown-allpot-info-card">
                        <Card.Body className="text-center">
                          <p className="allpot-text mb-0">{"Drawdown value"}</p>
                          <div className="mt-2 mb-2">
                            <span className="allpot-value">
                              {" "}
                              £
                              {addCommas(
                                props.drawDownPotBreakdown?.totalValue?.split(
                                  ".", // eslint-disable-line
                                )[0], // eslint-disable-line
                              )}
                            </span>
                            <span className="allpot-subsetsmall">{`.${
                              props.drawDownPotBreakdown?.totalValue?.split(
                                ".", // eslint-disable-line
                              )[1]
                            }`}</span>
                          </div>
                          <Buttons
                            name="View more"
                            className="tertiary allpot-view-breakdown-btn"
                            handleClick={props.handleViewAllPots}
                            id={FUNDNAME.DRAWDOWN}
                          ></Buttons>
                        </Card.Body>
                      </Card>
                    </Carousel.Item>
                  ) : (
                    ""
                  )}
                  {props.drawDownPotBreakdown?.potInfo?.length === 1 ? (
                    <Carousel.Item
                      key={
                        parseFloat(props.savingsPotBreakdown?.totalValue) === 0
                          ? 0
                          : 1
                      }
                      style={{ backgroundColor: "var(--blue-100)" }}
                      className="savings-carousel-card-item"
                    >
                      <div className="carousel-text-wrapper">
                        <span className="contribution-name">
                          {props?.savingsPotBreakdown?.potInfo[0]?.potId}
                        </span>
                        <span className="contribution-name">
                          {props.drawDownPotBreakdown?.potInfo[0]?.potName}
                        </span>
                        <div className="mt-2">
                          <span className="pot-breakdown-value">
                            {" "}
                            £
                            {`${addCommas(
                              props.drawDownPotBreakdown?.potInfo[0]?.drawdownValue?.split(
                                ".", // eslint-disable-line
                              )[0], // eslint-disable-line
                            )}`}
                          </span>
                          <span className="pot-breakdown-subsetsmall">
                            {`.00`}
                          </span>
                        </div>
                        {parseFloat(
                          props.drawDownPotBreakdown?.potInfo[0]?.drawdownValue, // eslint-disable-line
                        ) === 0 ? (
                          ""
                        ) : (
                          <Buttons
                            name="View breakdown"
                            className="tertiary pot-view-breakdown-btn"
                            handleClick={props.handleSavingsViewBreakdown}
                            id={`${props.drawDownPotBreakdown?.potInfo[0]?.potId}-drawDown`}
                          ></Buttons>
                        )}
                      </div>
                    </Carousel.Item>
                  ) : (
                    ""
                  )}
                </Carousel>
                {props.savingsPotBreakdown?.potInfo?.length > 1 &&
                props.savingsPotBreakdown?.totalValue > 0 &&
                selectedIndex === 0 ? (
                  <div className="toggle-btn">
                    <CustomizedSwitches
                      checked={props.checked}
                      onChange={props.onChange}
                      label1={"Total"}
                      label2={"Savings breakdown"}
                      id={FUNDNAME.SAVINGS}
                    />
                  </div>
                ) : props.drawDownPotBreakdown?.potInfo?.length > 1 &&
                  props.drawDownPotBreakdown?.totalValue > 0 &&
                  selectedIndex === 1 ? (
                  <div className="drawdown-toggle-btn">
                    <CustomizedSwitches
                      checked={props.checked}
                      onChange={props.onChange}
                      label1={"Total"}
                      label2={"Drawdown breakdown"}
                      id={FUNDNAME.DRAWDOWN}
                    />
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : props.savingsBreakdown ? (
              <Carousel
                interval={interval}
                onSelect={(e) => handleSelect(e)}
                className={
                  selectedIndex === 0
                    ? "control-prev"
                    : props?.savingsPotBreakdown?.potInfo?.length - 1 ===
                        selectedIndex
                      ? "control-next"
                      : ""
                }
              >
                {props?.savingsPotBreakdown?.potInfo?.map((item, index) => {
                  return (
                    <Carousel.Item
                      key={index}
                      className="savings-carousel-card-item"
                    >
                      <div className="carousel-text-wrapper">
                        {item?.status === "Active" ? (
                          <div className="d-flex justify-content-center">
                            <p className="active-status-text">{item?.status}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        <span className="contribution-name">{item?.potId}</span>
                        <span className="contribution-name">
                          {item?.potName}
                        </span>
                        <div className="mt-3">
                          <span className="pot-breakdown-value">
                            {" "}
                            £
                            {`${addCommas(item?.totalPotValue?.split(".")[0])}`}
                          </span>
                          <span className="pot-breakdown-subsetsmall">
                            {`.00`}
                          </span>
                        </div>
                        {parseFloat(item?.totalPotValue) === 0 ? (
                          ""
                        ) : (
                          <Buttons
                            name="View breakdown"
                            className="tertiary pot-view-breakdown-btn"
                            handleClick={props.handleSavingsViewBreakdown}
                            id={`${item?.potId}-savings`}
                          ></Buttons>
                        )}
                      </div>
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            ) : props.drawDownBreakdown ? (
              <Carousel
                interval={interval}
                onSelect={(e) => handleSelect(e)}
                className={
                  selectedIndex === 0
                    ? "control-prev"
                    : props?.drawDownPotBreakdown?.potInfo?.length - 1 ===
                        selectedIndex
                      ? "control-next"
                      : ""
                }
              >
                {props?.drawDownPotBreakdown?.potInfo?.map((item, index) => {
                  return (
                    <Carousel.Item
                      key={index}
                      style={{ backgroundColor: "var(--blue-100)" }}
                      className="savings-carousel-card-item"
                    >
                      <div className="carousel-text-wrapper">
                        <span className="contribution-name">{item?.potId}</span>
                        <span className="contribution-name">
                          {item?.potName}
                        </span>
                        <div className="mt-3">
                          <span className="pot-breakdown-value">
                            {" "}
                            £
                            {`${addCommas(item?.drawdownValue?.split(".")[0])}`}
                          </span>
                          <span className="pot-breakdown-subsetsmall">
                            {`.00`}
                          </span>
                        </div>
                        {parseFloat(item?.drawdownValue) === 0 ? (
                          ""
                        ) : (
                          <Buttons
                            name="View breakdown"
                            className="tertiary pot-view-breakdown-btn"
                            handleClick={props.handleSavingsViewBreakdown}
                            id={`${item?.potId}-drawDown`}
                          ></Buttons>
                        )}
                      </div>
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            ) : !props?.savingsCarouselData?.potBreakDown?.every(
                (contribution) =>
                  parseFloat(contribution.contributedValue) === 0, // eslint-disable-line
              ) ? (
              <Carousel
                interval={interval}
                onSelect={(e) => handleSelect(e)}
                className={
                  selectedIndex === 0
                    ? "control-prev"
                    : props?.savingsCarouselData?.potBreakDown?.length - 1 ===
                        selectedIndex
                      ? "control-next"
                      : ""
                }
              >
                {props?.savingsCarouselData?.potBreakDown?.map(
                  (item, index) => {
                    return (
                      <Carousel.Item
                        key={index}
                        style={{
                          border: `${
                            props.fundName === FUNDNAME.SAVINGS
                              ? "solid 1.5px var(--fuchsia-100)"
                              : "solid 1.5px  var(--blue-100)"
                          }`,
                        }}
                        className="carousel-card-item"
                      >
                        <div className="carousel-text-wrapper">
                          <span className="contribution-name">
                            {item?.contributionName}
                          </span>
                          {item?.contributionName ===
                            "Employer contributions" &&
                            item?.isSalarySacrifice === true && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={tooltip}
                                trigger={["hover", "focus"]}
                                delay={{ show: 250, hide: 400 }}
                              >
                                <span
                                  className="tooltip-icon"
                                  tabIndex={0}
                                  style={{
                                    pointerEvents: "auto",
                                    cursor: "help",
                                  }}
                                >
                                  <Icons
                                    iconname="tool-tip"
                                    variant="icon-sixteen-px"
                                  />
                                </span>
                              </OverlayTrigger>
                            )}
                          <div className="mt-3">
                            <span className="contribution-value">
                              {String(item?.contributedValue)?.includes("-")
                                ? `-£${addCommas(
                                    Math.trunc(
                                      item?.contributedValue?.split("-")[1], // eslint-disable-line
                                    ), // eslint-disable-line
                                  )}.`
                                : `£${addCommas(
                                    Math.trunc(
                                      item?.contributedValue, // eslint-disable-line
                                    ), // eslint-disable-line
                                  )}.`}
                            </span>
                            <span className="contribution-value-subset">
                              {(Math.abs(item?.contributedValue) % 1)
                                .toFixed(2)
                                .substring(2)}
                            </span>
                          </div>
                        </div>
                      </Carousel.Item>
                    );
                  }, //eslint-disable-line
                )}
              </Carousel>
            ) : (
              ""
            )}
          </Col>
        </>
      ) : type === "Investment Card Carousel" ? (
        <Carousel defaultActiveIndex={1}>
          {investmentCardCarouselData?.map((item, index) => {
            return (
              <Carousel.Item key={index} interval={interval}>
                {item.content}
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : type === "Investment Card Carousel two" ? (
        <Carousel defaultActiveIndex={1}>
          {investmentCardCarouselData?.map((item, index) => {
            return (
              <Carousel.Item key={index} interval={interval}>
                {item.content}
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : type === "learn-carousel" ? (
        <Carousel defaultActiveIndex={0}>
          {props?.promoCard?.map((item, index) => {
            return (
              <Carousel.Item key={index} interval={interval}>
                <div className="learn-container">
                  <Row className="learn-carousel">
                    <Col
                      className={
                        item?.properties?.articleTheme?.label === "Pale Fuchsia"
                          ? "Pale-Fuchsia"
                          : item?.properties?.articleTheme?.label
                      }
                      xs={{ span: 12, order: 2 }}
                      md={{ span: 7, order: 1 }}
                      lg={{ span: 7, order: 1 }}
                    >
                      <p className="read-timer mt-4 mb-4 ms-5 me-5">
                        <Icons
                          iconname={
                            item?.properties?.articleTheme?.label === "Blue" ||
                            item?.properties?.articleTheme?.label === "Fuchsia"
                              ? "clock-white"
                              : "clock"
                          }
                          variant="icon-sixteen-px me-2"
                        />
                        {
                          item?.properties?.articleHeader?.items[0]?.content
                            ?.properties?.articleTimeToRead
                        }{" "}
                        {item?.articleType === "Article"
                          ? "read"
                          : item?.articleType === "Webinar"
                            ? "webinar"
                            : ""}
                        <span className="align-right">
                          {item?.properties?.articleType === "Article" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "read-white"
                                  : "read"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : item.properties.articleType === "Video" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "video-white"
                                  : "video"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : item.properties.articleType === "Webinar" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "seat-white"
                                  : "seat"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : (
                            ""
                          )}
                        </span>
                        <hr />
                      </p>
                      <p className="title mt-4 ms-5 me-5">
                        <b>
                          {
                            item?.properties?.articleHeader?.items[0]?.content
                              ?.properties?.articleTitle
                          }
                        </b>
                      </p>
                      <div
                        className=" mb-4 ms-5 me-5"
                        dangerouslySetInnerHTML={{
                          __html:
                            item?.properties?.articleHeader?.items[0]?.content
                              ?.properties?.articleDescription?.markup,
                        }}
                      ></div>
                      {item?.properties?.articleType === "Article" ? (
                        <Buttons
                          name={"Read"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickRead(item)}
                        />
                      ) : item.properties.articleType === "Video" ? (
                        <Buttons
                          name={"Watch"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickVideo(item)}
                        />
                      ) : item.properties.articleType === "Webinar" ? (
                        <Buttons
                          name={"Book your place"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickWebinar(item)}
                        />
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col
                      className="carousel-image"
                      xs={{ span: 12, order: 1 }}
                      md={{ span: 5, order: 2 }}
                      lg={{ span: 5, order: 2 }}
                    >
                      <img
                        height="110%"
                        width="110%"
                        alt={
                          item?.properties?.articleHeader?.items[0]?.content
                            ?.properties?.articleImage?.items[0]?.content
                            ?.properties?.alternateTextSingle
                        }
                        src={`${cmsConfig?.baseUrl}${item?.properties?.articleHeader?.items[0]?.content?.properties?.articleImage?.items[0]?.content?.properties?.image[0]?.url}`}
                      ></img>
                    </Col>
                  </Row>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : type === "learn-carousel-one" ? (
        <Carousel defaultActiveIndex={0}>
          {props?.promoCard?.map((item, index) => {
            return (
              <Carousel.Item key={index} interval={interval}>
                <div className="learn-container">
                  <Row className="learn-carousel-one">
                    <Col
                      className={
                        item?.properties?.articleTheme?.label === "Pale Fuchsia"
                          ? "Pale-Fuchsia"
                          : item?.properties?.articleTheme?.label
                      }
                      xs={{ span: 12, order: 2 }}
                      md={{ span: 7, order: 1 }}
                      lg={{ span: 7, order: 1 }}
                    >
                      <p className="read-timer mt-4 mb-4 ms-5 me-5">
                        <Icons
                          iconname={
                            item?.properties?.articleTheme?.label === "Blue" ||
                            item?.properties?.articleTheme?.label === "Fuchsia"
                              ? "clock-white"
                              : "clock"
                          }
                          variant="icon-sixteen-px me-2"
                        />
                        {
                          item?.properties?.articleHeader?.items[0]?.content
                            ?.properties?.articleTimeToRead
                        }{" "}
                        {item?.articleType === "Article"
                          ? "read"
                          : item?.articleType === "Webinar"
                            ? "webinar"
                            : ""}
                        <span className="align-right">
                          {item?.properties?.articleType === "Article" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "read-white"
                                  : "read"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : item.properties.articleType === "Video" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "video-white"
                                  : "video"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : item.properties.articleType === "Webinar" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "seat-white"
                                  : "seat"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : (
                            ""
                          )}
                        </span>
                        <hr />
                      </p>
                      <p className="title mt-4 ms-5 me-5">
                        <b>
                          {
                            item?.properties?.articleHeader?.items[0]?.content
                              ?.properties?.articleTitle
                          }
                        </b>
                      </p>
                      <div
                        className=" mb-4 ms-5 me-5"
                        dangerouslySetInnerHTML={{
                          __html:
                            item?.properties?.articleHeader?.items[0]?.content
                              ?.properties?.articleDescription?.markup,
                        }}
                      ></div>
                      {item?.properties?.articleType === "Article" ? (
                        <Buttons
                          name={"Read"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickRead(item)}
                        />
                      ) : item.properties.articleType === "Video" ? (
                        <Buttons
                          name={"Watch"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickVideo(item)}
                        />
                      ) : item.properties.articleType === "Webinar" ? (
                        <Buttons
                          name={"Book your place"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickWebinar(item)}
                        />
                      ) : (
                        ""
                      )}
                      {item?.properties?.articleType === "Article" ? (
                        <Row>
                          <div className="date-text mt-3 ms-5 mb-2">
                            {moment(
                              item?.properties?.articleHeader?.items[0]?.content //eslint-disable-line
                                ?.properties?.articlePublishedDate, //eslint-disable-line
                            ).format("DD/MM/YYYY")}
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col
                      className="carousel-image"
                      xs={{ span: 12, order: 1 }}
                      md={{ span: 5, order: 2 }}
                      lg={{ span: 5, order: 2 }}
                    >
                      <img
                        height="500"
                        width="130%"
                        alt={
                          item?.properties?.articleHeader?.items[0]?.content
                            ?.properties?.articleImage?.items[0]?.content
                            ?.properties?.alternateTextSingle
                        }
                        src={`${cmsConfig?.baseUrl}${item?.properties?.articleHeader?.items[0]?.content?.properties?.articleImage?.items[0]?.content?.properties?.image[0]?.url}`}
                      ></img>
                    </Col>
                  </Row>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : type === "learn-carousel-full-one" ? (
        <Carousel defaultActiveIndex={0}>
          {props?.promoCard?.map((item, index) => {
            return (
              <Carousel.Item key={index} interval={interval}>
                <div className="learn-container">
                  <Row className="learn-carousel-full-one">
                    <Col
                      className={
                        item?.properties?.articleTheme?.label === "Pale Fuchsia"
                          ? "Pale-Fuchsia"
                          : item?.properties?.articleTheme?.label
                      }
                      xs={{ span: 12, order: 2 }}
                      md={{ span: 7, order: 1 }}
                      lg={{ span: 7, order: 1 }}
                    >
                      <p className="read-timer mt-4 mb-4 ms-5 me-5">
                        <Icons
                          iconname={
                            item?.properties?.articleTheme?.label === "Blue" ||
                            item?.properties?.articleTheme?.label === "Fuchsia"
                              ? "clock-white"
                              : "clock"
                          }
                          variant="icon-sixteen-px me-2"
                        />
                        {
                          item?.properties?.articleHeader?.items[0]?.content
                            ?.properties?.articleTimeToRead
                        }{" "}
                        {item?.articleType === "Article"
                          ? "read"
                          : item?.articleType === "Webinar"
                            ? "webinar"
                            : ""}
                        <span className="align-right">
                          {item?.properties?.articleType === "Article" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "read-white"
                                  : "read"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : item.properties.articleType === "Video" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "video-white"
                                  : "video"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : item.properties.articleType === "Webinar" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "seat-white"
                                  : "seat"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : (
                            ""
                          )}
                        </span>
                        <hr />
                      </p>
                      <p className="title mt-4 ms-5 me-5">
                        <b>
                          {
                            item?.properties?.articleHeader?.items[0]?.content
                              ?.properties?.articleTitle
                          }
                        </b>
                      </p>
                      <div
                        className=" mb-4 ms-5 me-5"
                        dangerouslySetInnerHTML={{
                          __html:
                            item?.properties?.articleHeader?.items[0]?.content
                              ?.properties?.articleDescription?.markup,
                        }}
                      ></div>
                      {item?.properties?.articleType === "Article" ? (
                        <Buttons
                          name={"Read"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickRead(item)}
                        />
                      ) : item.properties.articleType === "Video" ? (
                        <Buttons
                          name={"Watch"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickVideo(item)}
                        />
                      ) : item.properties.articleType === "Webinar" ? (
                        <Buttons
                          name={"Book your place"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickWebinar(item)}
                        />
                      ) : (
                        ""
                      )}
                      {item?.properties?.articleType === "Article" ? (
                        <Row>
                          <div className="date-text mt-3 ms-5 mb-2">
                            {moment(
                              item?.properties?.articleHeader?.items[0]?.content //eslint-disable-line
                                ?.properties?.articlePublishedDate, //eslint-disable-line
                            ).format("DD/MM/YYYY")}
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col
                      className="carousel-image"
                      xs={{ span: 12, order: 1 }}
                      md={{ span: 5, order: 2 }}
                      lg={{ span: 5, order: 2 }}
                    >
                      <img
                        height="500"
                        width="140%"
                        alt={
                          item?.properties?.articleHeader?.items[0]?.content
                            ?.properties?.articleImage?.items[0]?.content
                            ?.properties?.alternateTextSingle
                        }
                        src={`${cmsConfig?.baseUrl}${item?.properties?.articleHeader?.items[0]?.content?.properties?.articleImage?.items[0]?.content?.properties?.image[0]?.url}`}
                      ></img>
                    </Col>
                  </Row>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : type === "learn-carousel-full" ? (
        <Carousel defaultActiveIndex={0}>
          {props?.promoCard?.map((item, index) => {
            return (
              <Carousel.Item key={index} interval={interval}>
                <div className="learn-container">
                  <Row className="learn-carousel-full">
                    <Col
                      className={
                        item?.properties?.articleTheme?.label === "Pale Fuchsia"
                          ? "Pale-Fuchsia"
                          : item?.properties?.articleTheme?.label
                      }
                      xs={{ span: 12, order: 2 }}
                      md={{ span: 7, order: 1 }}
                      lg={{ span: 7, order: 1 }}
                    >
                      <p className="read-timer mt-4 mb-4 ms-5 me-5">
                        <Icons
                          iconname={
                            item?.properties?.articleTheme?.label === "Blue" ||
                            item?.properties?.articleTheme?.label === "Fuchsia"
                              ? "clock-white"
                              : "clock"
                          }
                          variant="icon-sixteen-px me-2"
                        />
                        {
                          item?.properties?.articleHeader?.items[0]?.content
                            ?.properties?.articleTimeToRead
                        }{" "}
                        {item?.articleType === "Article"
                          ? "read"
                          : item?.articleType === "Webinar"
                            ? "webinar"
                            : ""}
                        <span className="align-right">
                          {item?.properties?.articleType === "Article" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "read-white"
                                  : "read"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : item.properties.articleType === "Video" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "video-white"
                                  : "video"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : item.properties.articleType === "Webinar" ? (
                            <Icons
                              iconname={
                                item?.properties?.articleTheme?.label ===
                                  "Blue" ||
                                item?.properties?.articleTheme?.label ===
                                  "Fuchsia"
                                  ? "seat-white"
                                  : "seat"
                              }
                              variant="icon-sixteen-px"
                            />
                          ) : (
                            ""
                          )}
                        </span>
                        <hr />
                      </p>
                      <p className="title mt-4 ms-5 me-5">
                        <b>
                          {
                            item?.properties?.articleHeader?.items[0]?.content
                              ?.properties?.articleTitle
                          }
                        </b>
                      </p>
                      <div
                        className=" mb-4 ms-5 me-5"
                        dangerouslySetInnerHTML={{
                          __html:
                            item?.properties?.articleHeader?.items[0]?.content
                              ?.properties?.articleDescription?.markup,
                        }}
                      ></div>
                      {item?.properties?.articleType === "Article" ? (
                        <Buttons
                          name={"Read"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickRead(item)}
                        />
                      ) : item.properties.articleType === "Video" ? (
                        <Buttons
                          name={"Watch"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickVideo(item)}
                        />
                      ) : item.properties.articleType === "Webinar" ? (
                        <Buttons
                          name={"Book your place"}
                          className="carousel-button ms-5"
                          handleClick={() => onClickWebinar(item)}
                        />
                      ) : (
                        ""
                      )}
                      {item?.properties?.articleType === "Article" ? (
                        <Row>
                          <div className="date-text mt-3 ms-5 mb-2">
                            {moment(
                              item?.properties?.articleHeader?.items[0]?.content //eslint-disable-line
                                ?.properties?.articlePublishedDate, //eslint-disable-line
                            ).format("DD/MM/YYYY")}
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col
                      className="carousel-image"
                      xs={{ span: 12, order: 1 }}
                      md={{ span: 5, order: 2 }}
                      lg={{ span: 5, order: 2 }}
                    >
                      <img
                        height="500"
                        width="140%"
                        alt={
                          item?.properties?.articleHeader?.items[0]?.content
                            ?.properties?.articleImage?.items[0]?.content
                            ?.properties?.alternateTextSingle
                        }
                        src={`${cmsConfig?.baseUrl}${item?.properties?.articleHeader?.items[0]?.content?.properties?.articleImage?.items[0]?.content?.properties?.image[0]?.url}`}
                      ></img>
                    </Col>
                  </Row>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : type === "Processing your application" ? (
        <>
          <Carousel defaultActiveIndex={0}>
            {rafinaltimeline.map((item, index) => {
              return (
                <Carousel.Item key={index} interval={interval}>
                  {item.content}
                </Carousel.Item>
              );
            })}
          </Carousel>
        </>
      ) : type === "broadcast-carousel" ? (
        <Carousel interval={interval} className="broadcast-carousel">
          {props.messages?.map((item, index) => {
            return (
              <Carousel.Item key={index} interval={interval}>
                <div
                  className="segmented-messages"
                  dangerouslySetInnerHTML={{
                    __html: item?.content?.properties?.segmentedMessage?.markup,
                  }}
                />
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : (
        ""
      )}
    </>
  );
};

export default CarouselComponent;
